import * as React from "react";
import BaseModelMap from "../models/BaseModelMap";
import PageGroup from "../models/PageGroup";
import BaseDialog, { Field } from "./BaseDialog";

import { useState } from "react";
import Logger from "../Logger";

const logger = new Logger();

export default function PageGroupDialog(props: { parent?: BaseModelMap<PageGroup>; obj?: PageGroup }) {
  const { parent, obj } = props;

  const [name, setName] = useState(obj?.name || getNewPageGroupName());
  const edit = obj != undefined;

  if (!edit && parent == undefined) {
    logger.error("parent == undefined");
  }

  // check if name is already assingned
  function checkValidName(name: string): boolean {
    var double = false;
    if (!parent) {
      return true;
    }
    parent.items.forEach((pageGroup) => {
      if (state.noDoubleValue.ciEquals(pageGroup.name, name)) {
        double = true;
      }
    });

    return !double;
  }

  function getNewPageGroupName(): string {
    var pageGroupName = state.translate("components.PageGroup", "Seitengruppe ");

    var i = 1;
    var newPageGroupName = pageGroupName + i;
    while (!checkValidName(newPageGroupName)) {
      newPageGroupName = pageGroupName + i;
      i++;
    }

    return newPageGroupName;
  }

  return (
    <BaseDialog
      title={
        edit
          ? state.translate("pageGroupDialog.editPageGroup", "Edit PageGroup")
          : state.translate("pageGroupDialog.createPageGroup", "Create new PageGroup")
      }
      onClose={() => {
        logger.log("room dialog closed");
        return true;
      }}
      onOk={() => {
        if (edit) {
          if (obj) {
            obj.name = name;
            obj.raiseOnChange();
          }
        } else {
          const newPageGroup = new PageGroup({ name: name }, parent);
          parent?.add(newPageGroup);
        }
        return true;
      }}
    >
      <div style={{ padding: "20px" }}>
        {state.translate("pageGroupDialog.createhereNewPageGroup", "Du legst hier eine neue Seitengruppe an.")} <br />
      </div>

      <Field label={state.translate("name", "Name")}>
        <input
          className="input"
          maxLength={state.maxCharLimit.text}
          defaultValue={name}
          onChange={(ev) => {
            setName(ev.target.value);
          }}
        ></input>
      </Field>
    </BaseDialog>
  );
}
